import {PWMAT_RESOURCE} from './consts'

export const Tutorials = [
  {
    name:'自洽计算',
    url:PWMAT_RESOURCE+'tutorials-ppt/SCF.pptx',
    file_name:'SCF.pptx'
  },
  {
    name:'能带计算',
    url:PWMAT_RESOURCE+'tutorials-ppt/BAND.pptx',
    file_name:'BAND.pptx'
  },
  {
    name:'态密度计算',
    url:PWMAT_RESOURCE+'tutorials-ppt/DOS.pptx',
    file_name:'DOS.pptx'
  },
  {
    name:'DFT+U计算',
    url:PWMAT_RESOURCE+'tutorials-ppt/DFT+U.pptx',
    file_name:'DFT+U.pptx'
  },
  {
    name:'自旋极化计算',
    url:PWMAT_RESOURCE+'tutorials-ppt/SPIN.pptx',
    file_name:'SPIN.pptx'
  },
  {
    name:'自旋轨道耦合&非线性磁矩',
    url:PWMAT_RESOURCE+'tutorials-ppt/SOC&NONCOLLINEAR.pptx',
    file_name:'SOC&NONCOLLINEAR.pptx'
  },
  {
    name:'原子位置及晶格优化计算',
    url:PWMAT_RESOURCE+'tutorials-ppt/RELAX.pptx',
    file_name:'RELAX.pptx'
  },
  {
    name:'分子动力学计算',
    url:PWMAT_RESOURCE+'tutorials-ppt/MD.pptx',
    file_name:'MD.pptx'
  },
  {
    name:'过渡态计算',
    url:PWMAT_RESOURCE+'tutorials-ppt/NEB.pptx',
    file_name:'NEB.pptx'
  },
  {
    name:'含时密度泛函&非绝热分子动力学',
    url:PWMAT_RESOURCE+'tutorials-ppt/TDDFT&NAMD.pptx',
    file_name:'TDDFT&NAMD.pptx'
  },
  ]
